<template>
    <div class="uc-org-manage">
        <compWrapper title="基本信息" theme="primary">
            <compFormEdit
                :formdata="getBase"
                v-model="formData"
                ref="form"
                class="margin-top-15"
            ></compFormEdit>
            <vButtonGroup slot="footer">
                <vButton theme="success" @click="updateSystem">保存</vButton>
                <vButton @click="cancel">取消</vButton>
            </vButtonGroup>
        </compWrapper>
        <compWrapper v-if="showEmail" title="财务信息" theme="primary">
            <compFormEdit
                :formdata="getFinanceBase"
                v-model="formData"
                class="margin-top-15"
            ></compFormEdit>
        </compWrapper>
        <vLoading size="large" transfer :loading="loading"></vLoading>
    </div>
</template>

<script>
import {
    HttpUpdateSystem,
    HttpSystemDetail,
    HttpOrgrolesAll,
    HttpOrgrTypeList,
    HttpOrgContextBindList,
    HttpCheckPcpfx,
    HttpGetPcpfx,
    HttpGetOption,
} from "@/service/ucadm";
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            loading: false,
            type: this.$route.params.type,
            id: this.$route.query.id,
            formData: {
                name: "",
                code: "",
                roleLabel: "",
                companyAddress: "",
                companyName: "",
                contactName: "",
                contactTel: "",
                orgroleIds: "",
                serviceType: 0,
                status: 1,
                pcpfx: "",
            },
            orgroleList: [],
            orgRoleLabelList: [],
            orgContextBindList: [],
            checkPcpfx: false,
            disablePcpfx: false,
            needPcpfx: true,
            initOrgIds: [],
            showEmail: false,
        };
    },
    async created() {
        if (this.isEdit) {
            this.disablePcpfx = true;
        }
        if (!this.isEdit) {
            this.getOrgOption();
        }
        this.getAllOrgRoles();
        this.getOrgTypeList();
        this.getSystemDetail();
        this.getOrgContextBindList();
        this.showEmail = this.handleAuth("fbb.org.billSetting")
    },
    computed: {
        ...mapGetters(["isSuper", "getAuthUserOrgId"]),
        isEdit() {
            return this.type === "edit";
        },
        getStatusList() {
            return [
                {
                    value: 1,
                    label: "激活",
                },
                {
                    value: 2,
                    label: "停用",
                },
                {
                    value: 3,
                    label: "关闭",
                },
            ];
        },
        getServiceTypeList() {
            return [
                {
                    value: 0,
                    label: "未设定",
                },
                {
                    value: 1,
                    label: "商户服务",
                },
                {
                    value: 2,
                    label: "仓储服务",
                },
                {
                    value: 3,
                    label: "物流发运服务",
                },
                {
                    value: 4,
                    label: "当地配送服务",
                },
                {
                    value: 5,
                    label: "代理运营服务",
                },
            ];
        },
        getFinanceBase(){
            return [
                {
                    label: "账单邮件接收人",
                    key: "optionBillRecipientEmail",
                    props:{
                        placeholder: "多个联系人用英文逗号隔开"
                    },
                    required: false,
                },
                {
                    label: "账单邮件抄送人",
                    key: "optionBillCopyEmail",
                    props:{
                        placeholder: "多个联系人用英文逗号隔开"
                    },required: false,
                },
            ]
        },
        getBase() {
            return [
                {
                    label: "组织名称",
                    key: "name",
                },
                {
                    label: "组织角色",
                    key: "orgroleIds",
                    tag: "vSelect",
                    required: false,
                    props: {
                        multiple: true,
                        filterable: true,
                    },
                    options: this.orgroleList,
                    show:
                        this.handleAuth("uc.organization.setrole") &&
                        !(this.getAuthUserOrgId == this.id && !this.isSuper),
                },
                {
                    label: "状态",
                    key: "status",
                    tag: "vSelect",
                    options: this.getStatusList,
                },
                {
                    label: "服务类型",
                    key: "serviceType",
                    tag: "vSelect",
                    options: this.getServiceTypeList,
                },
                {
                    label: "唯一标识符",
                    key: "code",
                    query: this.isEdit,
                },
                {
                    label: "组织类型",
                    key: "roleLabel",
                    tag: "vSelect",
                    options: this.orgRoleLabelList,
                    query: this.isEdit,
                    show: this.handleAuth("uc.organization.edit_rolelabel"),
                },
                {
                    label: "产品编码前缀",
                    // key: 'pcpfx',
                    tag: "div",
                    require: true,
                    children: (h) => {
                        if (!this.needPcpfx) {
                            return (
                                <div>
                                    <Input
                                        disabled
                                        value={this.formData.pcpfx}
                                        onInput={this.handleInput}
                                    ></Input>
                                </div>
                            );
                        }
                        return (
                            <div>
                                <div class="pcpfx-item">
                                    <span
                                        style="position: absolute; left: 33px;"
                                        class="color-error"
                                    >
                                        *
                                    </span>
                                    <Input
                                        style={
                                            !this.isEdit ? "width: 100%;" : ""
                                        }
                                        // disabled={this.formData.pcpfx && this.isEdit}
                                        disabled={this.disablePcpfx}
                                        class="pcpfx-item-input"
                                        value={this.formData.pcpfx}
                                        onInput={this.handleInput}
                                        placeholder="ERP SKU若开启了自动生成，自动生成时会以此编码作为ERP SKU的前缀。"
                                    ></Input>
                                    <Button
                                        style={
                                            this.isEdit ? "display: none;" : ""
                                        }
                                        class="pcpfx-item-button"
                                        type="primary"
                                        on-click={this.generatePcpfx}
                                    >
                                        重新生成
                                    </Button>
                                </div>
                                <div class="color-error">
                                    只允许1-4位的字母或数字，全局唯一{" "}
                                </div>
                            </div>
                        );
                    },
                },
                {
                    label: "公司名称",
                    key: "companyName",
                },
                {
                    label: "公司地址",
                    key: "companyAddress",
                },
                {
                    label: "联系人",
                    key: "contactName",
                },
                {
                    label: "联系电话",
                    key: "contactTel",
                },
                {
                    label: "关联组织",
                    key: "organizationIds",
                    tag: "vSelect",
                    required: false,
                    props: {
                        multiple: true,
                        clearable: false,
                        filterable: true,
                    },
                    options: this.orgContextBindList,
                    show: this.handleAuth("uc.organization.access"),
                },
                {
                    label: "销售员邮箱",
                    key: "optionSalePersonEmail",
                },
            ];
        },
    },
    methods: {
        async getOrgOption() {
            console.log(this.formData);
            await HttpGetOption({
                id: this.isEdit ? this.id : 0,
                optionName: "autogen_erpsku",
                hostId: -1,
                globalDefault: 1,
            }).then(
                (res) => {
                    console.log(res);
                    if (res.data && res.data.optionValue == 1) {
                        return this.needPcpfx = true;
                    }
                    this.needPcpfx = false;
                },
                (err) => {
                    console.log(err);
                }
            );
        },
        checkPcpfxValid() {
            console.log(this.formData.pcpfx);
        },
        handleInput(val) {
            this.formData.pcpfx = val;
            this.checkPcpfxValid = false;
        },
        async generatePcpfx(event, value) {
            await HttpGetPcpfx({
                pcpfx: value,
            }).then(
                (res) => {
                    console.log(res);
                    this.formData.pcpfx = res.data.pcpfx;
                    this.checkPcpfxValid = true;
                },
                (err) => {
                    console.log(err);
                }
            );
        },
        cancel() {
            this.$router.push({ name: "orgManage" });
        },
        //组织类型
        async getOrgContextBindList() {
            if (!this.handleAuth("uc.organization.access")) return;
            const formData = this.isEdit ? { contextId: this.id } : {};
            await HttpOrgContextBindList(formData)
                .then((res) => {
                    const data = res.data || {};
                    this.orgContextBindList = (data || []).map(function (item) {
                        return {
                            value: item.id,
                            label: `${item.name}(${item.code})`,
                        };
                    });
                })
                .catch((err) => {
                    this.$VMessage.error(err.message);
                });
        },
        handleContextBindIds(data) {
            const accessModules =
                data.organizationDataAccessResult.accessModules || [];
            const orgModule =
                accessModules.find((item) => item.module === "Organization") ||
                {};
            this.formData.organizationIds = (
                orgModule.accessResourceIds || []
            ).filter((item) => item != this.id);
            // 刚进页面时的关联组织ids
            this.initOrgIds = this.formData.organizationIds;
        },
        //绑定关联组织
        async getOrgTypeList() {
            await HttpOrgrTypeList({ id: 0 })
                .then((res) => {
                    const data = res.data || {};
                    this.orgRoleLabelList = (data.roleLabelRows || []).map(
                        function (item) {
                            return {
                                value: item.label,
                                label: item.name,
                            };
                        }
                    );
                })
                .catch((err) => {
                    this.$VMessage.error(err.message);
                });
        },
        async updateSystem() {
            let vaild = await this.$refs.form.validate();
            if (!vaild) return;

            const regEmail = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/;
            if(this.formData.optionBillRecipientEmail){
                const receiveEmail = this.formData.optionBillRecipientEmail.split(',');
                let receiveTrue = true;
                for( let i = 0 ; i < receiveEmail.length ; i++){
                    if(!regEmail.test(receiveEmail[i])){
                        receiveTrue = false;
                        this.$VMessage.error('请填写正确的接收人邮箱！');
                        break;
                    }
                }
                if(!receiveTrue) return
            }
            if( this.formData.optionBillCopyEmail){
                const copyEmail = this.formData.optionBillCopyEmail.split(',');
                let copyTrue = true;
                for( let i = 0 ; i < copyEmail.length ; i++){
                    if(!regEmail.test(copyEmail[i])){
                        copyTrue = false;
                        this.$VMessage.error('请填写正确的抄送人邮箱！');
                        break;
                    }
                }
                if(!copyTrue) return
            }

            if( !regEmail.test(this.formData.optionSalePersonEmail)){
                this.$VMessage.error('请填写正确的销售员邮箱！');
                return;
            }
            if (this.needPcpfx) {
                if (!this.checkPcpfx) {
                    if (!this.formData.pcpfx)
                        return this.$VMessage.error("产品编码前缀必填");
                    if (
                        this.formData.pcpfx.length > 4 ||
                        !/[A-Za-z0-9]/.test(this.formData.pcpfx)
                    ) {
                        return this.$VMessage.error(
                            "产品编码前缀最多为4位的字母或数字"
                        );
                    }
                    let flag = false;
                    if (!this.isEdit) {
                        await this.generatePcpfx({}, this.formData.pcpfx);
                    }
                    await HttpCheckPcpfx({
                        pcpfx: this.formData.pcpfx,
                        excludeId: this.isEdit ? this.id : 0,
                    }).then(
                        (res) => {
                            flag = !res.data;
                        },
                        (err) => {
                            this.$VMessage.error(err.message);
                        }
                    );
                    if (!flag)
                        return this.$VMessage.error(
                            "产品编码前缀未通过验证，请修改或重新生成"
                        );
                }
            }
            let cleanOrg = false;
            if (this.isEdit) {
                if (this.initOrgIds.length > 0 && !this.formData.organizationIds.length) {
                    cleanOrg = true;
                }
            }
            // console.log(this.initOrgIds, this.formData.organizationIds, cleanOrg);
            let formData = {
                ...this.formData,
                doSetOrgrole: this.handleAuth("uc.organization.setrole")
                    ? 1
                    : 0,
                optionAutoGenErpsku: this.needPcpfx ? 1: 0
            };
            formData.orgroleIds = (formData.orgroleIds || []).join(",");
            formData.organizationIds = (formData.organizationIds || []).join(
                ","
            );
            if (cleanOrg) {
                formData.cleanupOrganizationAccess = 1;
            }
            // return console.log(formData.cleanupOrganizationAccess);
            this.loading = true;
            const response = await HttpUpdateSystem(formData).catch((err) => {
                this.loading = false;
                this.$VMessage.error(err.message);
            });
            if (response) {
                this.loading = false;
                this.$VMessage.success(response.message);
                this.$router.push({ name: "orgManage" });
            }
        },
        async getAllOrgRoles() {
            const response = await HttpOrgrolesAll({
                id: this.isEdit ? this.id : 0,
            }).catch((err) => {
                this.$VMessage.error(err.message);
            });
            if (response) {
                this.orgroleList = (response.data || []).map(function (item) {
                    return {
                        value: item.id,
                        label: item.displayName,
                    };
                });
            }
        },
        async getSystemDetail() {
            if (!this.isEdit) return;
            this.loading = true;
            const response = await HttpSystemDetail({ id: this.id }).catch(
                (err) => {
                    this.loading = false;
                    this.$VMessage.error(err.message);
                }
            );
            if (response) {
                const data = response.data || {};
                // this.orgRoleLabelList = (data.roleLabelRows || []).map(function (item) {
                // 	return {
                // 		value: item.label,
                // 		label: item.name
                // 	}
                // });
                this.loading = false;
                this.formData = {
                    ...data.entity,
                    optionBillCopyEmail: data.optionBillCopyEmail,
                    optionBillRecipientEmail: data.optionBillRecipientEmail,
                    optionSalePersonEmail: data.optionSalePersonEmail,
                    orgroleIds: data.roleIds || [],
                };
                console.log('this.formData',this.formData)
                // 编辑时取loadData中的字段
                this.needPcpfx = data.optionAutoGenErpsku == 1 ? true : false;
                // if (!this.formData.pcpfx) {
                //     this.disablePcpfx = false;
                // }
                this.handleContextBindIds(data);
                // this.$VMessage.success(response.message);
            }
        },
    },
};
</script>
<style lang="scss">
.uc-org-manage {
    .pcpfx-item {
        display: flex;
        justify-content: space-between;
        .pcpfx-item-input {
            width: 90%;
        }
        .pcpfx-item-button {
            margin-left: 15px;
        }
    }
}
</style>
